import { EvasysActionsFactory } from '../essential/redux/actions/evasys-actions.factory';

const actionsFactory = new EvasysActionsFactory<any>('GLOBAL');

export const ClearActionSet = actionsFactory.createCustomActionSet<void, void>('Clear', false);
